import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {AddComplementsComponent} from '../components/common/add-complements/add-complements.component';
import {ConfirmationDialogComponent} from '../components/common/confirmation-dialog/confirmation-dialog.component';
import {VideoFrameComponent} from '../components/common/dialogs/video-frame/video-frame.component';
import {NotificationDialogComponent} from '../components/common/notification-dialog/notification-dialog.component';
import {PaymentData} from '../models/application/payment-data.model';
import {MenuMovilComponent} from '../components/common/dialogs/menu/menu.component';
import {PromofirmasComponent} from '../components/common/dialogs/promofirmas/promofirmas.component';

@Injectable({
    providedIn: 'root',
})
export class DialogService {
    constructor(private matDialog: MatDialog) {
    }

    showVideoFrame(url, onComplete?: () => void): void {
        this.matDialog.closeAll();
        const dialogRef = this.matDialog.open(VideoFrameComponent, {
            hasBackdrop: true,
            disableClose: false,
            maxWidth: '700px',
            position: { top: '150px'},
            panelClass: 'videoframe-panel-dialog',
            backdropClass: 'videoframe-backdrop',
            data: url
        });

        dialogRef.afterClosed().subscribe(
            data => {
                if (onComplete) {
                    onComplete();
                }
            }
        );
    }

    showMenu(onComplete?: () => void): void {
        this.matDialog.closeAll();
        const dialogRef = this.matDialog.open(MenuMovilComponent, {
            hasBackdrop: true,
            disableClose: false,
            width: '70%',
            height: '100%',
            position: {top: '0px', left: '0px'},
            panelClass: 'videoframe-panel-dialog',
            backdropClass: 'videoframe-backdrop'
        });

        dialogRef.afterClosed().subscribe(
            data => {
                if (onComplete) {
                    onComplete();
                }
            }
        );
    }

    showPromo(onComplete?: () => void): void {
        this.matDialog.closeAll();
        const dialogRef = this.matDialog.open(PromofirmasComponent, {
            hasBackdrop: true,
            disableClose: true,
            width: '800px',
            position: {top: '150px'},
            // height: '400px',
            panelClass: 'promo-panel-dialog',
            backdropClass: 'promo-backdrop'
        });
        dialogRef.afterClosed().subscribe(
            data => {
                if (onComplete) {
                    onComplete();
                }
            }
        );
    }

    showConfirmationDialog(
        title: string,
        message: string,
        callbackAccept: () => void,
        buttonAcceptText?: string,
        buttonRejectText?: string
    ): void {
        this.matDialog.closeAll();
        const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
            hasBackdrop: true,
            disableClose: true,
            panelClass: 'confirm-dialog',
            backdropClass: 'confirm-backdrop',
            data: {
                title,
                message,
                callbackAccept,
                buttonAcceptText,
                buttonRejectText
            }
        });

        dialogRef.afterClosed().subscribe(
            data => {
                if (data) {
                    callbackAccept();
                }
            }
        );
    }

    showNotificationDialog(
        title: string,
        message: string,
        buttonAcceptText?: string,
        callbackAccept?: () => void
    ): void {
        this.matDialog.closeAll();
        const dialogRef = this.matDialog.open(NotificationDialogComponent, {
            hasBackdrop: true,
            disableClose: true,
            panelClass: 'confirm-dialog',
            backdropClass: 'confirm-backdrop',
            data: {
                title,
                message,
                callbackAccept,
                buttonAcceptText
            }
        });
        dialogRef.afterClosed().subscribe(
            data => {
                if (data && callbackAccept) {
                    callbackAccept();
                }
            }
        );
    }
}
